<template>
  <input
    v-model="value"
    class="input-text-border-none !h-6"
    :maxlength="max"
    type="text"
    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
    @blur="changeInput"
  />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  // props: {
  //   params: {
  //     type: Object,
  //     default: null
  //   }
  // },
  data() {
    return {
      value: '',
      type: 'number',
      max: 0,
      colName: null
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    if (this.params?.max !== null && this.params?.max !== undefined) {
      this.max = this.params.max
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.textInputChange(
        this.params,
        this.value,
        this.colName
      )
    }
  }
})
</script>
<style lang="scss"></style>
